"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FC, JSX, useState } from "react";
import { initializeStore } from "@/stores/rootStore";
import { RootStoreContext } from "@/contexts/storesContext";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ErrorBoundary from "@/components/entities/error-boundary";

interface IRQHydrate {
  children: JSX.Element;
}

const StoreProvider: FC<IRQHydrate> = ({ children }) => {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 1000 * 60 * 5, // 5 минут данные будут свежими
            refetchOnMount: false,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  return (
    <ErrorBoundary>
      <RootStoreContext.Provider value={initializeStore()}>
        <QueryClientProvider client={client}>
          <ReactQueryDevtools />
          {children}
        </QueryClientProvider>
      </RootStoreContext.Provider>
    </ErrorBoundary>
  );
};

export default StoreProvider;
